import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import './index.css';
import './custem.scss'
import AppWrapper from './AppWrapper';
import "@activehub/common-components-spa-resource/dist/index.min.css";
import { routerBasePath } from './constants/Config';
import { ScrollToTop } from './utils/CustomHooks';
import * as serviceWorker from './serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <HashRouter basename={routerBasePath}>
            <ScrollToTop />
            <AppWrapper />
        </HashRouter>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
